import { ProductAddonGroupUpdatePage } from '@/features/product-addon-group/pages/ProductAddonGroupUpdatePage'
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/admin/product-addon-group/$id/update')({
  beforeLoad({ context }) {
    if (!context.authAdapter.can({ permissions: ["product_addon_group.edit"] })) {
      throw redirect({ to: "/403" });
    }
  },
  component: ProductAddonGroupUpdatePage,
})
